var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSafariPinnedTab = function SvgSafariPinnedTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h128v128H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H0v128h128V0Zm0 120H8V8h112Z",
    fill: "#342616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#342616",
    d: "M80 24v-8H48v96h32v-8H56V48h24v-8H56V24h24z"
  })));
};

export { SvgSafariPinnedTab as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Qm94PSIwIDAgMTI4IDEyOCI+PHRpdGxlPmljb248L3RpdGxlPjxyZWN0IHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0iTTEyMCwwSDBWMTI4SDEyOFYwWm0wLDEyMEg4VjhIMTIwWiIgZmlsbD0iIzM0MjYxNiIvPjxwb2x5Z29uIHBvaW50cz0iODAgMjQgODAgMTYgNTYgMTYgNTMgMTYgNDggMTYgNDggMTEyIDUzIDExMiA1NiAxMTIgODAgMTEyIDgwIDEwNCA1NiAxMDQgNTYgNDggODAgNDggODAgNDAgNTYgNDAgNTYgMjQgODAgMjQiIGZpbGw9IiMzNDI2MTYiLz48L3N2Zz4=";